import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Elements, StripeProvider, injectStripe } from 'react-stripe-elements'

import CartProgress from 'components/CartProgress'
import CartPhone from 'components/CartPhone'
import CartInfos from 'components/CartInfos'
import CartEnd from 'components/CartEnd'

import { getPaymentDataAction } from 'actions/cellars'

const InjectedCartInfos = injectStripe(CartInfos)

class Cart extends React.Component {
  constructor(props) {
    super(props)
    this.stepsComponents = {
      auth: CartPhone,
      infos: CartInfos,
      end: CartEnd,
    }

    const { stepsBeforeAuth } = props

    if (Array.isArray(stepsBeforeAuth)) {
      for (const step of stepsBeforeAuth) {
        const { key, component } = step
        this.stepsComponents[key] = component
      }
    }
  }

  componentDidMount() {
    const { cellarId, getPaymentData } = this.props

    getPaymentData(cellarId)
  }

  render() {
    const {
      cart,
      disableAuth,
      summaryComponent,
      stepsBeforeAuth,
      backLinkText,
      backLinkFunction,
      cellars,
      cellarId,
    } = this.props

    const cellar = cellars[cellarId]
    if (!cellar || !cellar.paymentData || !cellar.paymentData._id) {
      return null
    }

    let currentComponent = this.stepsComponents[cart.step]
    if (cart.step === 'infos' && cellar.paymentData.stripeApiKey) {
      currentComponent = InjectedCartInfos
    }

    let stepComponent = React.createFactory(currentComponent)(this.props)
    if (cellar.paymentData.stripeApiKey) {
      stepComponent = (
        <StripeProvider apiKey={ cellar.paymentData.stripeApiKey }>
          <Elements>
            { stepComponent }
          </Elements>
        </StripeProvider>
      )
    }

    const summary = summaryComponent ? (
      <div className="reservation-step space--top-2">
        <div className="grid__item">
          {
            React.createFactory(summaryComponent)(Object.assign({
              showUserData: cart.step === 'end',
            }, this.props))
          }
        </div>
      </div>
    ) : null

    return (
      <div className="reservation">
        <div className="reservation__progress">
          <div className="wrap">
            <CartProgress
              step={cart.step}
              disableAuth={disableAuth}
              stepsBeforeAuth={stepsBeforeAuth}
              backLinkText={backLinkText}
              backLinkFunction={backLinkFunction}
            />
          </div>
        </div>
        <hr id="cart__hr" />
        <div className="reservation__body">
          <div className="wrap">
            { stepComponent }
            { summary }
          </div>
        </div>
      </div>
    )
  }
}

Cart.propTypes = {
  cart: PropTypes.object.isRequired,
  cellarId: PropTypes.string.isRequired,
  updateCart: PropTypes.func.isRequired,
  authenticationRequest: PropTypes.func.isRequired,
  cartOperation: PropTypes.func.isRequired,
  clearCart: PropTypes.func.isRequired,
  company: PropTypes.string.isRequired,
  resourceId: PropTypes.string,
  paymentDisabled: PropTypes.bool,
  metaData: PropTypes.array,
  disableAuth: PropTypes.bool,
  disableCoupon: PropTypes.bool,
  stepsBeforeAuth: PropTypes.array,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  summaryComponent: PropTypes.func,
  backLinkText: PropTypes.string.isRequired,
  backLinkFunction: PropTypes.func.isRequired,
  finishButtonText: PropTypes.string.isRequired,
  getPaymentData: PropTypes.func.isRequired,
  cellars: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    cellars: state.cellars,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getPaymentData: getPaymentDataAction,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Cart)
